// material-ui
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// assets
import LogoImg from 'assets/images/logTrans.png';

export default function Footer() {
  return (
    <Box
      sx={{
        mt: 'auto',
        backgroundColor: '#22856d', // soft light green
        color: '#000201ff'            // dark green text
      }}
    >
      {/* Top section */}
      <Box sx={{ px: { xs: 2, md: 6 }, py: 6 }}>
        <Grid container spacing={4}>
          {/* Company summary */}
          <Grid item xs={12} md={4}>
            <Stack spacing={2}>
              <Box
                component="img"
                src={LogoImg}
                alt="Verification Professional"
                sx={{ width: 140 }}
              />
              <Typography variant="body2" sx={{ color: 'grey.300' }}>
                Providing secure, fast, and reliable employment verifications.
                We operate our own data center using state-of-the-art systems
                developed in-house, backed by over 30 years of experience in
                automated employment and income verification.
              </Typography>

              <Link
                href="https://www.linkedin.com/company/verificationprofessional/"
                target="_blank"
                underline="hover"
                sx={{ color: '#0a66c2', fontWeight: 500 }}
              >
                LinkedIn
              </Link>
            </Stack>
          </Grid>

          {/* Resources */}
          <Grid item xs={12} sm={6} md={2}>
            <Stack spacing={1.2}>
              <Typography variant="subtitle2">Resources</Typography>
              <Link
                href="https://www.ftc.gov/enforcement/statutes/fair-credit-reporting-act"
                target="_blank"
                color="grey.300"
                underline="hover"
              >
                Fair Credit Reporting Act
              </Link>
            </Stack>
          </Grid>

          {/* Company */}
          <Grid item xs={12} sm={6} md={2}>
            <Stack spacing={1.2}>
              <Typography variant="subtitle2">Company</Typography>
              <Link href="https://verifyposition.com/appPrivacyPolicyGoogle.html" target= '_blank' color="grey.300" underline="hover">
                App Privacy
              </Link>
            </Stack>
          </Grid>

          {/* Location */}
          <Grid item xs={12} md={4}>
            <Stack spacing={1.2}>
              <Typography variant="subtitle2">Location</Typography>

              <Typography variant="body2" color="grey.300">
                5815 Oleander Drive, Suite 200<br />
                Wilmington, NC 28403, USA
              </Typography>

              <Link href="tel:9108335601" color="grey.300" underline="hover">
                910-833-5601
              </Link>

              <Link
                href="mailto:info@VerificationProfessional.com"
                color="grey.300"
                underline="hover"
              >
                info@VerificationProfessional.com
              </Link>

              <Link
                href="https://www.vprous.com"
                target="_blank"
                color="grey.300"
                underline="hover"
              >
                https://www.vprous.com
              </Link>

              <Box sx={{ pt: 1 }}>
                <Link
                  href="https://www.sitelock.com/verify.php?site=vprous.com"
                  target="_blank"
                  underline="none"
                >
                  Site
                  <Box
                    component="img"
                    src="https://shield.sitelock.com/shield/vprous.com"
                    alt="SiteLock"
                    sx={{ maxWidth: 140 }}
                  />
                </Link>
              </Box>
            </Stack>
          </Grid>
        </Grid>
      </Box>

      <Divider sx={{ borderColor: 'rgba(255,255,255,0.15)' }} />

      {/* Bottom section */}
      <Box
        sx={{
          px: { xs: 2, md: 6 },
          py: 2,
          display: 'flex',
          flexDirection: { xs: 'column', md: 'row' },
          alignItems: { xs: 'flex-start', md: 'center' },
          justifyContent: 'space-between',
          gap: 2
        }}
      >
        <Typography variant="caption" color="grey.400">
          © {new Date().getFullYear()} ComputerSoft. All rights reserved.
        </Typography>

        <Stack direction="row" spacing={2}>
          <Link
            href="/free/assets/img/FCRAV.pdf"
            target="_blank"
            variant="caption"
            color="grey.300"
            underline="hover"
          >
            FCRA Individual
          </Link>
          <Link
            href="/free/assets/img/FCRAP.pdf"
            target="_blank"
            variant="caption"
            color="grey.300"
            underline="hover"
          >
            FCRA Users Of
          </Link>
          <Link
            href="/free/assets/img/priv.pdf"
            target="_blank"
            variant="caption"
            color="grey.300"
            underline="hover"
          >
            Privacy Policy
          </Link>
        </Stack>
      </Box>
    </Box>
  );
}
